import { Injectable, InjectionToken } from '@angular/core';

export interface AppConfig {
  region: string;
  userPoolId: string;
  clientId: string;
  bucket: string;
  host: string;
  roles: string[];
  mixPanelToken: string;
  sentryDsn: string;
  apiEndpoints: {
    [key: string]: string;
  };
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig | null = null;

  constructor() {}

  setConfig(config: AppConfig): void {
    this.config = config;
  }

  get<K extends keyof AppConfig>(key: K): AppConfig[K] {
    if (!this.config) {
      throw new Error('Configuration not loaded. Make sure APP_INITIALIZER is configured properly.');
    }
    return this.config[key];
  }

  getAll(): AppConfig {
    if (!this.config) {
      throw new Error('Configuration not loaded. Make sure APP_INITIALIZER is configured properly.');
    }
    return this.config;
  }

  isLoaded(): boolean {
    return this.config !== null;
  }
}
